import { useFormContext } from 'react-hook-form';
import { useDeepCompareDebounce } from '~/hooks/useDeepCompareDebounce';
import { DocumentBuilderForm } from '~/types/document-builder';

export const useDebouncedBuilderValues = () => {
  const { watch } = useFormContext<DocumentBuilderForm>();
  const values = watch();
  const debouncedValues = useDeepCompareDebounce(values, 500);
  return debouncedValues;
};
